import React from "react";
import { observer } from "mobx-react";
import classNames from "classnames";
import format from "@app/lib/format";

const HtmlViewer = observer(({ html, className, ...rest }) => {
    const content = format.sanitize(html, {
        p: ["class"],
        ul: ["class"],
        ol: ["class"],
        li: ["class"],
        br: [],
        hr: ["class"],
        h1: ["class"],
        h2: ["class"],
        h3: ["class"],
        h4: ["class"],
    });

    return (
        <div
            className={classNames("html", className)}
            dangerouslySetInnerHTML={{ __html: content }}
            {...rest}
        ></div>
    );
});

export default HtmlViewer;
